import { Link, useParams } from 'react-router-dom';

import { useFetchBookDetails, useFetchWikipediaDetails } from '../../hooks/Hooks';
import Loader from '../../components/Loader';
import { useAtom } from 'jotai';
import { darkModeAtom } from "../../App";

import errorBlack from "../../assets/img/black-error-img.png";
import errorWhite from "../../assets/img/white-error-img.png";

export default function BookDetail() {
    const [darkMode] = useAtom(darkModeAtom);
    const errorSource = darkMode ? errorWhite : errorBlack;
    const {id} = useParams();
    const {book, isLoading: isBookLoading} = useFetchBookDetails(id);
    const {wikiData, isLoading: isWikiLoading} = useFetchWikipediaDetails(book?.title);

    if (isBookLoading || isWikiLoading) {
        return <Loader/>;
    }

    return (
        <>
            <section>
                <div>
                    <div className="container mx-auto flex flex-col items-center">
                        <div className="mx-auto p-8 mt-12 mb-6 flex items-center justify-center">
                            <div className="flex flex-col items-center">
                                <h1 className="max-w-2xl mb-4 text-4xl font-extrabold tracking-tight leading-none md:text-2xl xl:text-4xl text-center">
                                    {book.title || "Aucune information"}
                                </h1>
                                <img className="inline-block mt-4 md:mt-0 p-8 md:p-0" src={book.cover.medium || errorSource} alt={book.title || "Aucune information"} />
                            </div>
                        </div>
                        <div className="w-full p-8 mt-12 mb-6 md:mb-0 md:mt-0 ml-0 md:ml-12 justify-center">
                            <div className="relative overflow-x-auto">
                                <table className="w-full text-sm border text-left rtl:text-right">
                                    <tbody>
                                    <tr className="border-b">
                                        <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap">
                                            Auteur : {book.authors ? book.authors.map(author => author.name).join(', ') : "Aucune information"}
                                        </th>
                                    </tr>
                                    <tr className="border-b">
                                        <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap">
                                            Année de publication : {book.first_publish_year || "Aucune information"}
                                        </th>
                                    </tr>
                                    <tr className="border-b">
                                        <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap">
                                            Nombre de pages : {book.number_of_pages || "Aucune information"}
                                        </th>
                                    </tr>
                                    <tr className="border-b">
                                        <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap">
                                            Éditeur : {book.publishers ? book.publishers.map(publisher => publisher.name).join(', ') : "Aucune information"}
                                        </th>
                                    </tr>
                                    <tr>
                                        <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap description">
                                            Description : {wikiData?.extract || "Aucune information"}
                                        </th>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="flex justify-center mt-10">
                                <Link to={`https://en.wikipedia.org/wiki/${book.title}`} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center px-5 py-3 text-base font-medium text-center text-white border border-blue-900 bg-blue-900 rounded-lg hover:bg-blue-800 hover:text-white focus:ring-4 focus:ring-gray-100">
                                    Lien vers la page Wikipedia
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}